import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import Icons from "../../../../src/components/icons";
import * as React from 'react';
export default {
  HeroLayout,
  Icons,
  React
};